import { render, staticRenderFns } from "./new.data-loader-entities.page.vue?vue&type=template&id=0dc4a3ff&"
import script from "./new.data-loader-entities.page.vue?vue&type=script&lang=js&"
export * from "./new.data-loader-entities.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports